<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Cliente</div>
  <div class="mr-8">
    @if (checkPermission('criar', 'legal')) {
      <button mat-raised-button class="btn-add mr-2" (click)="newClient()">
        Novo Cliente
      </button>
    }
    @if (checkPermission('criar', 'sub')) {
      <button mat-raised-button class="btn-add" (click)="newSubClient()">
        Novo SubCliente
      </button>
    }
  </div>
</div>

<mat-tab-group animationDuration="400ms">
  @if (checkPermission('paginado', 'legal')) {
    <mat-tab label="Cliente" [disabled]="!checkPermission('paginado', 'legal')">
      <!--  <mat-tab label="Jurídico">-->
      <legal-entity-client></legal-entity-client>
    </mat-tab>
  }
  <!--  <mat-tab label="Fisico" disabled>-->
  <!--    <individual-client></individual-client>-->
  <!--  </mat-tab>-->
  @if (checkPermission('paginado', 'sub')) {
    <mat-tab
      label="Sub Cliente"
      [disabled]="!checkPermission('paginado', 'sub')"
    >
      <sub-client></sub-client>
    </mat-tab>
  }
  @if (checkPermission('paginado', 'consultant')) {
    <mat-tab
      label="Consultor"
      [disabled]="!checkPermission('paginado', 'consultant')"
    >
      <consultant-client></consultant-client>
    </mat-tab>
  }
</mat-tab-group>
